export default "/_next/static/images/62fdc53032634ad9232f4dff6a17bcda.png";